import { render, staticRenderFns } from "./ReferenceLink.vue?vue&type=template&id=55aeee57&scoped=true&"
var script = {}
import style0 from "./ReferenceLink.vue?vue&type=style&index=0&id=55aeee57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55aeee57",
  null
  
)

export default component.exports